// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__ET0y7","sectionRose":"Section_sectionRose__N0Coo","sectionVintage":"Section_sectionVintage__Ba3rt","sectionCoach":"Section_sectionCoach__iWEX6"};